import React from 'react';
import { useParams } from 'react-router';

import { useFretsStore, getSelectedInstrument } from '../../../store/useFretsStore';
import { gridColumns } from '../../../utils/grid.utils';
import { getMidiPitch } from '../../../utils/pitch.utils';
import { playPluckedNote } from '../../../utils/audio.utils';
import { Z_INDEX, GRID_MARGIN, COLORS } from '../../../config/frets.config';
import Portal from '../../Portal/Portal.component';
import { PORTALS } from '../../../config/frets.config';

const NotesComponent = () => {
    const { exercise } = useParams();
    const isExercise = Boolean(exercise);
    const exerciseState = useFretsStore(state => state.exercises[String(exercise ?? '')]);
    const beat = exerciseState?.beat ?? 0;
    const pattern = exerciseState?.pattern ?? [];
    const stage = exerciseState?.stage ?? 1;
    const notes = exerciseState?.notes ?? [];
    const selectedInstrumentId = useFretsStore(state => state.selectedInstrumentId);
    const activeInstrumentDefinition = useFretsStore(state => state.activeInstrumentDefinition);
    const instrument = getSelectedInstrument(activeInstrumentDefinition || selectedInstrumentId);
    const running = useFretsStore(state => state.sequencePlaying);
    const activeIndex = running && beat > 0 && pattern.length
        ? (beat - 1) % pattern.length
        : -1;
    const activePosition = activeIndex >= 0 ? pattern[activeIndex] : null;
    const activeString = activePosition?.string ?? '';
    const activeFret = activePosition?.fret ?? '';

    const playNote = (obj) => {
        try {
            playPluckedNote(getMidiPitch(instrument, obj.string, obj.fret));
        } catch (error) {
            // Audio is optional; fretboard interaction should remain available if unsupported.
        }
    };

    return <Portal id={PORTALS.FRET_GRID}>
        <div className="legacy-notes" style={{ '--string-count': instrument.strings.length, '--notes-min-height': `${instrument.strings.length}px`, '--grid-columns': `${GRID_MARGIN}vw ${gridColumns(24)} ${GRID_MARGIN}vw`, '--note-z': Z_INDEX.Note, '--note-color': COLORS.Note.color, '--note-border': COLORS.Note.borderColor, '--note-bg': COLORS.Note.backgroundColor, '--note-active-color': COLORS.Note.colorAlt, '--note-active-border': COLORS.Note.borderColorAlt, '--note-active-bg': COLORS.Note.backgroundColorAlt }}>
            {stage && notes.length && notes[stage - 1]?.map((obj, idx) =>
                <div
                    className={`legacy-note ${obj.string === activeString && obj.fret === activeFret ? 'legacy-note-active' : ''}`}
                    key={`Notes/${obj.string}/${obj.fret}/${obj.note}/${idx}`}
                    style={{ '--note-column': obj.fret + 1, '--note-row': obj.string, cursor: 'pointer' }}
                    role="button"
                    tabIndex={0}
                    aria-label={`Play string ${obj.string}, fret ${obj.fret}, ${obj.note}`}
                    onClick={() => playNote(obj)}
                    onKeyDown={event => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            playNote(obj);
                        }
                    }}
                >
                    <span>{isExercise ? obj.fret : obj.note}</span>
                </div>)}
        </div>
    </Portal>;
};

export default NotesComponent;
